import { ExternalTool } from '@customer-apps/shared/enums';

export const environment = {
    production: true,
    validateAccess: true,
    applicationName: 'ViGuide Planning',
    baseUrl: 'https://viguide-planning.viessmann.com',
    baseApiUrl: 'https://api.viessmann.com',
    environmentHeaders: {},
    externalTools: {
        [ExternalTool.HeatPumpPlanner]: 'https://viguide-planning-heatpump.viessmann.com',
        [ExternalTool.PhotovoltaicPlanner]: 'https://viguide-planning-pv.viessmann.com',
        [ExternalTool.QuoteAssist]: 'https://quote-assist.viessmann.com',
        [ExternalTool.PartnerShop]: 'https://shop.viessmann.com'
    },
    serviceWorker: true,
    environment: 'production',
    partnerPortalBaseUrl: 'https://partnerportal.viessmann.com',
    everestApiUrl: 'https://api.viessmann.com',
    accountApiUrl: 'https://account.viessmann.com',
    registerRedirectUrl: 'https://viguide-planning.viessmann.com',
    localeConfig: {
        localStorageKey: 'locale'
    },
    storageKeys: {
        locale: 'locale',
        nextRoute: 'nextRoute',
        lockProjectId: 'lockProjectId'
    },
    projectLockConfig: {
        nextAttemptLockDelay: 5000, // 5 seconds
        verifyLockPollingInterval: 1000 * 60 * 10 // 10 minutes
    },
    csrfTokenConfig: {
        appId: 'viguide-planning-projects',
        localStorageKey: 'csrf_token',
        apiUrl: 'https://api.viessmann.com/auth/v1/saml/csrf'
    },
    meUrl: 'https://api.viessmann.com/users/v1/users/me',
    samlConfig: {
        requestLoginUrl: 'https://api.viessmann.com/saml/sso/request'
    },
    globalHeader: {
        iamBackgroundImage: 'iam_lpi_000001.png'
    },
    featureFlags: {
        multiFamilyHouse: false,
        orders: false
    }
};
